/*
Monotype Foundry Platform API
Version 1.0.0

Definition: QuarterlyRoyaltiesStatementDownloadRequest

Properties:
  reportId: string (required)
*/

var QuarterlyRoyaltiesStatementDownloadRequest = (function () {
  function validateQuarterlyRoyaltiesStatementDownloadRequest (arg) {
    // Validate reportId
    if (!arg.reportId) {
      throw new Error('QuarterlyRoyaltiesStatementDownloadRequest.reportId: Missing property')
    }
    if (arg.reportId && !(typeof arg.reportId === 'string')) {
      throw new Error('QuarterlyRoyaltiesStatementDownloadRequest.reportId: Wrong type: Got \'' + (typeof arg.reportId) + '\', but expected: \'string\'')
    }
  }
  function buildQuarterlyRoyaltiesStatementDownloadRequest (arg) {
    var QuarterlyRoyaltiesStatementDownloadRequest = arg
    // Complete reportId
    // Expected Type: string
    QuarterlyRoyaltiesStatementDownloadRequest.reportId = QuarterlyRoyaltiesStatementDownloadRequest.reportId || ''
    return QuarterlyRoyaltiesStatementDownloadRequest
  }
  return {
    validate: validateQuarterlyRoyaltiesStatementDownloadRequest,
    build: buildQuarterlyRoyaltiesStatementDownloadRequest
  }
})()

module.exports = QuarterlyRoyaltiesStatementDownloadRequest
